<div class="info-chart" data-cy="info-chart">
  @if (hasTitleSection) {
    <div class="info-chart-title-wrapper">
      <div class="info-chart-title description"
      data-cy="info-chart-title">{{configuration.description}}</div>
      <div class="info-chart-title"
      data-cy="info-chart-title-value">{{getCurrencyFormatter(configuration.totalValue, configuration.currency)  | undefinedValue}}</div>
    </div>
  }
  <div #line class="info-chart-line-section">
    <div [ngStyle]="gridLineAndZebraStyleFormatter()" class="info-chart-line-wrapper">
      @if (state.infoChartDataLine) {
        <div [ngStyle]="gridLineStyleFormatter(state.infoChartDataLine)" class="info-chart-line-wrapper">
          @for (infoData of state.infoChartDataLine; track infoData; let index = $index) {
            <div class="info-chart-line">
              <app-tooltip [disable]="disableTooltip"
                [dynamic]="false"
                [message]="infoData.intermediateState ? tooltipIntermidialTemplate : this.tooltipText(infoData, configuration.tooltip)">
                <div (click)="emitIdentifier(infoData)"
                  (mouseenter)="mouseHover(infoData.identifier)"
                  (mouseout)="mouseHover($event)"
                  [ngClass]="getStatusColor(infoData)"
                  [attr.data-cy]="getStatusDataCy(index)"
                class="info-chart-status"></div>
              </app-tooltip>
              @if (!infoData.intermediateState) {
                @if (infoData.percentage) {
                  <div class="info-chart-line-text text-line-color"
                  data-cy="info-chart-line-text-percentage">{{infoData.percentage | prettyPrintPercentage: 2 | undefinedValue}}</div>
                }
                @if (infoData.description) {
                  <app-tooltip [dynamic]="true" [message]="infoData.description">
                    <div class="info-chart-line-text"
                    data-cy="info-chart-line-text-description">{{infoData.description | undefinedValue}}</div>
                  </app-tooltip>
                }
                @if (infoData.value) {
                  <div class="info-chart-line-text"
                  data-cy="info-chart-line-text-value">{{getCurrencyFormatter(infoData.value, configuration.currency)}}</div>
                }
              }
            </div>
            <ng-container>
              <ng-template #tooltipIntermidialTemplate>
                <p>{{infoData.percentage | prettyPrintPercentage: 2 | undefinedValue}}</p>
                <p>{{infoData.description | undefinedValue}}</p>
                <p>{{getCurrencyFormatter(infoData.value, configuration.currency)}}</p>
                <br>
                  <p>{{tooltipText(infoData, configuration.tooltip)}}</p>
                </ng-template>
              </ng-container>
            }
          </div>
        }
        @if (state.infoChartDataZebra?.length > 0) {
          <div class="info-chart-zebra-wrapper">
            <app-tooltip [dynamic]="false" [message]="tooltipZebraTemplate"
              tooltipCustomClass="info-chart-zebra-tooltip">
              <div [ngClass]="{'closed' : allInfoChartDataClosed}" class="info-chart-zebra" data-cy="info-chart-zebra"></div>
            </app-tooltip>
            <ng-container>
              <ng-template #tooltipZebraTemplate>
                <p>{{this.state.zebraPercentage| prettyPrintPercentage: 2| undefinedValue}}</p>
                <br>
                  <p>{{configuration.zebraTooltip}}</p>
                </ng-template>
              </ng-container>
            </div>
          }
        </div>
      </div>
    </div>




